/**
 * Must match where the SPA is deployed (BrowserRouter basename) and axios full-page redirects.
 *
 * - CRA production: `PUBLIC_URL` comes from package.json `homepage` (`/nirman`).
 * - If your host strips `PUBLIC_URL` from the bundle, set `REACT_APP_ROUTER_BASENAME=/nirman`
 *   in `.env.production`.
 * - Local `npm start`: `PUBLIC_URL` is empty — basename stays `''` so `http://localhost:3000/login` works.
 */
function normalizeBase(value) {
  if (value == null || value === '') return '';
  return String(value).replace(/\/$/, '');
}

const fromPublic = normalizeBase(process.env.PUBLIC_URL);
const fromEnv = normalizeBase(process.env.REACT_APP_ROUTER_BASENAME);

export const ROUTER_BASENAME =
  fromPublic ||
  fromEnv ||
  (process.env.NODE_ENV === 'development' ? '' : '/nirman');
